import dayjs from 'dayjs';

export class Duration {
  days: number;
  weeks: number;
  months: number;
  years: number;
  constructor({ days, weeks, months, years }: { days?: number; weeks?: number; months?: number; years?: number }) {
    this.days = days || 0;
    this.weeks = weeks || 0;
    this.months = months || 0;
    this.years = years || 0;
  }
  static fromISOString = (duration: string) => {
    const val = dayjs.duration(duration);

    // dayjs doesn't parse negative periods properly
    const isNegative = duration.startsWith('-');
    function invertIfNegative(value: number) {
      return isNegative && value !== 0 ? value * -1 : value;
    }

    // Work around bug in dayjs duration weeks
    // Limitation: we can't support periods with weeks _and_ any other period
    if (!val.years() && !val.months() && !val.days() && val.weeks()) {
      return new Duration({ weeks: invertIfNegative(val.weeks()) });
    }

    return new Duration({
      years: invertIfNegative(val.years()),
      months: invertIfNegative(val.months()),
      // Ignore weeks - limitation above
      days: invertIfNegative(val.days()),
      // We don't handle any periods shorter than days
    });
  };
  isNegative() {
    return this.days < 0 || this.weeks < 0 || this.months < 0 || this.years < 0;
  }
}
